import { setTrackingId } from "client/Misc/utils";
import { ReactElement, PropsWithChildren } from "react";
import styles from "./DialogFooter.module.less";
import classNames from "classnames";
import {
	ToolbarAlignmentContext,
	ToolbarAlignmentContextData
} from "../../Toolbar/ToolbarAlignmentContext";

const dialogFooterToolbarAlignment: ToolbarAlignmentContextData = {
	horizontalAlignment: "right",
	dropDownDirection: "up"
};

export type DialogFooterProps = {
	hasBorder?: boolean;
};

export const DialogFooter = (props: PropsWithChildren<DialogFooterProps>): ReactElement => {
	const {
		children,
		hasBorder = false
	} = props;

	return (
		<div
			{...setTrackingId("dialog-footer")}
			className={classNames(
				styles.root,
				{[styles.root_border]: hasBorder}
			)}
		>
			<ToolbarAlignmentContext.Provider value={dialogFooterToolbarAlignment}>
				{children}
			</ToolbarAlignmentContext.Provider>
		</div>
	);
};

DialogFooter.displayName = "DialogFooter";
